import { TurbineStatus } from "./TurbineStatus";
export default TurbineStatus;
